import ImageOverlayBox from './ImageOverlayBox';

export default ImageOverlayBox;
